export const avatar = {
  root: ({ props, parent }: Record<string, any>) => ({
    class: [
      // Font
      'tw-font-normal',
      {
        'max-xl:tw-text-sm': props.size == null || props.size === 'normal',
        'xl:tw-text-[20px]': props.size == null || props.size === 'normal',
        'tw-text-2xl': props.size === 'large',
        'tw-text-3xl': props.size === 'xlarge',
      },
      // Alignments
      'tw-inline-flex tw-items-center tw-justify-center',
      'tw-shrink-0',
      'tw-relative',
      // Sizes
      {
        'max-xl:tw-h-9 max-xl:tw-w-9': props.size === null || props.size === 'normal',
        'xl:tw-h-11 xl:tw-w-11': props.size == null || props.size === 'normal',
        'tw-w-16 tw-h-16': props.size === 'large',
        'tw-w-20 tw-h-20': props.size === 'xlarge',
      },
      { '-ml-4': parent.instance.$style?.name === 'avatargroup' },
      // Shapes
      {
        'max-xl:tw-rounded-md': props.shape === 'square',
        'xl:tw-rounded-xl': props.shape === 'square',
        'tw-rounded-full': props.shape === 'circle',
      },
      { 'tw-border-2': parent.instance.$style?.name === 'avatargroup' },
      // Colors
      'tw-bg-primary tw-dark:bg-surface-700 tw-text-teal-200',
      {
        'tw-border-white tw-dark:border-surface-800':
          parent.instance.$style?.name === 'avatargroup',
      },
    ],
  }),
  image: ({ props }: Record<string, any>) => ({
    class: [
      'tw-h-full tw-w-full',
      {
        'tw-rounded-lg': props.shape === 'square',
        'tw-rounded-full': props.shape === 'circle',
      },
    ],
  }),
};
